import { Box, Button, Stack, Typography } from '@mui/material';
import { Banda, Celda, Rotulo, ALTURA_TACTIL } from 'src/components/ui/casa';


// «Armé esto para vos»: una banda de 1 px con una celda por tarjeta (título, el porqué en una línea y el botón).
export default function TarjetasArmeEsto({ tarjetas, onAction, onRechazar }) {
  if (!Array.isArray(tarjetas) || tarjetas.length === 0) return null;
  return (
    <Box sx={{ mt: 1, width: '100%', minWidth: { sm: 360 } }}>
      <Rotulo sx={{ mb: 0.75 }}>Armé esto para vos</Rotulo>
      <Banda columnas={1}>
        {tarjetas.map((accion, idx) => (
          <Celda key={`${accion.payload?.id || accion.payload?.titulo}-${idx}`}>
            <Stack spacing={0.5}>
              <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{accion.payload.titulo}</Typography>
              {accion.payload.porque ? (
                <Typography variant="body2" color="text.secondary">
                  {accion.payload.porque}
                </Typography>
              ) : null}
              <Box>
                <Button
                  variant="outlined"
                  onClick={() => onAction?.(accion)}
                  sx={{ minHeight: ALTURA_TACTIL, textTransform: 'none', mt: 0.5 }}
                >
                  {accion.label || 'Ver cómo funciona'}
                </Button>
                {onRechazar ? (
                  <Button onClick={() => onRechazar(accion)} sx={{ minHeight: ALTURA_TACTIL, textTransform: 'none', mt: 0.5, ml: 1 }}>
                    Ahora no
                  </Button>
                ) : null}
              </Box>
            </Stack>
          </Celda>
        ))}
      </Banda>
    </Box>
  );
}
